<template>
  <div class="image-capture">
    <input
      ref="fileInput"
      type="file"
      accept="image/*"
      :capture="capture"
      v-bind="$attrs"
      @change="onFileChange"
      style="display: none"
    />
    <div
      @click="$el.querySelector('input[type=file]').click()"
      style="cursor: pointer"
    >
      <slot>
        <a-button type="primary" ghost block v-bind="buttonProps">
          Capturar Imagen
          <a-icon type="camera" />
        </a-button>
      </slot>
    </div>
    <!-- FILE -->
    <div v-if="fileDataUrl" class="image-preview">
      <img
        :src="fileDataUrl"
        alt="Captured Image"
        @click="onPreview"
        style="cursor: pointer"
      />
      <span class="file-name" @click="onPreview" style="cursor: pointer">
        {{ fileObject.name }} ({{ (fileObject.size / 1024).toFixed(2) }} KB)
      </span>
      <a-icon
        class="delete-btn"
        type="delete"
        style="cursor: pointer"
        @click="onRemove"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: "ImageCapture",
  props: {
    capture: {
      type: String,
      default: "environment",
    },
    buttonProps: {
      type: Object,
      default: () => ({}),
    },
    fileUrl: {
      type: File,
      default: null,
    },
  },
  emits: ["change", "remove", "preview"],
  data() {
    return {
      fileDataUrl: null,
      fileObject: null,
    };
  },
  methods: {
    onRemove() {
      this.fileDataUrl = null;
      this.fileObject = null;
      this.$refs.fileInput.value = null;
      this.$emit("remove");
    },
    onPreview() {
      this.$emit("preview", this.fileObject);
    },
    onFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.fileDataUrl = e.target.result;
          this.fileObject = {
            object: file,
            name: file.name,
            size: file.size,
            type: file.type,
            url: this.fileDataUrl,
          };
          this.$emit("change", file);
        };
        reader.readAsDataURL(file);
      }
    },
  },
  watch: {
    fileUrl: {
      immediate: true,
      deep: true,
      handler(newFile, oldFile) {
        if (newFile !== oldFile) {
          this.fileDataUrl = newFile;
        }
      },
    },
  },
};
</script>
<style scoped lang="scss">
@import "~@/assets/scss/variable";
.image-capture {
  .image-preview {
    margin-top: 8px;
    position: relative;
    height: 66px;
    padding: 8px;
    border: 1px solid var(--border-color);
    border-radius: 4px;
    display: flex;
    align-items: center;
    gap: 12px;
    .file-name {
      font-size: 14px;
      color: var(--danger);
    }
    img {
      display: block;
      width: 48px;
      height: 48px;
      overflow: hidden;
    }
    .delete-btn {
      position: absolute;
      right: 8px;
      top: 25px;
      line-height: 1;
      opacity: 1;
    }
  }
}
</style>
